import styled from '@emotion/styled';
import { iconSecondary, iconSecondaryHover, iconTertiaryHover } from '../../utils/inconsistentVars';
import { mobileOnly } from '../../utils/sharedStyles';

export const SEARCH_ICON = 'nav-search-icon';
export const SEARCH_END_ICON = 'nav-search-end-icon';

export const StyledSearch = styled('search')`
  // Adding z-index so that desktop header does not overlap the search input box
  z-index: 1;
  .gn-search-bar {
    top: 36px;
    position: inherit;
    padding-top: 0;

    &:not(.top-bar-visible) {
      top: 0px;
    }

    &.search-opened {
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      transition: grid-template-columns var(--podium-cds-motion-duration-400)
          var(--podium-cds-motion-easing-expressive),
        top var(--podium-cds-motion-easing-expressive) var(--podium-cds-motion-duration-400);
      padding-top: 12px;
      z-index: var(--podium-cds-elevation-10);
    }

    .search-input-container {
      background-color: var(--podium-cds-color-bg-secondary);
      transition: none;
      #${SEARCH_ICON} {
        color: var(--podium-cds-color-text-primary);
        background-color: ${iconSecondary};
        &::before {
          border-color: transparent;
        }
        &:hover {
          background: ${iconSecondaryHover};
          border-color: ${iconSecondaryHover};
        }

        &:not(:disabled) {
          &::before {
            border-color: transparent;
          }
        }
      }

      input,
      input::placeholder {
        font: var(--podium-cds-typography-body1-strong);
        background-color: inherit;
      }
    }
  }

  div.bar-search-results-tray {
    //search results tray container styles go here
    > * {
      margin-top: 48px;
      right: 0;
    }
    right: 0;
  }
  @media (max-width: 1200px) {
    .gn-search-bar {
      top: 0;

      &.search-opened {
        top: 0;
        padding-top: 12px;

        .bar-input-container {
          width: ${props => (props?.cancelText.length > 6 ? '90%' : '100%')};
        }

        div.bar-search-results-tray {
          min-height: 80vh;
          right: 0;
        }
      }
      &:not(.search-opened) {
        grid-template-columns: 0 36px 0;
        // preventing the closing animation for mobile because it looks weird
        transition: none;
        .search-input-container {
          #${SEARCH_ICON} {
            background-color: var(--podium-cds-color-bg-primary);
            &:hover {
              background: ${iconTertiaryHover};
              border-color: ${iconTertiaryHover};
            }
          }
          .search-input {
            width: 0;
            visibility: hidden;
            padding: 0;
          }
          .search-end-icon-container {
            width: 0;
            visibility: hidden;
          }
          div.bar-search-results-tray {
            min-height: 80vh;
            right: 0;
            width: 80%;
          }
        }
      }
    }
  }

  #${SEARCH_END_ICON} {
    color: var(--podium-cds-color-text-primary);
    background-color: ${iconSecondary};
    &::before {
      border-color: transparent;
    }
    &:hover {
      background-color: ${iconSecondaryHover};
      border-color: ${iconSecondaryHover};
    }
  }
`;

export const StyledVisualSearchResultsContainer = styled.div`
  overflow-y: scroll;

  @media (${mobileOnly}) {
    height: 100vh;
  }
`;
